import axios, { AxiosResponse } from "axios";
import { mel_url } from "./index";
import {
  basicOptionsInterface,
  brandingOptionsInterface,
  configInterface,
  orderingOptionsInterface,
  regOptionsInterface
} from "context/initialState/Config";

export default {
  adminLogin: (password: string) => {
    const config = {
      method: "POST",
      url: `${mel_url}/api/configure/admin/login`,
      data: { password: password },
      headers: {
        "Access-Control-Allow-Origin": "*"
      }
    };
    return axios(config)
      .then((isAuthenticated) => {
        return isAuthenticated;
      })
      .catch((err) => {
        throw err;
      });
  },
  getConfigurations: (org?: String) => {
    const config = {
      method: "GET",
      url: `${mel_url}/api/configure/${org}`,
      headers: {
        "Access-Control-Allow-Origin": "*"
      }
    };
    return axios(config)
      .then((configResponse: AxiosResponse) => {
        
        // const coordinatorConfigurations = configResponse.data.organizationOptions.find((coord: any) => coord.id === configResponse.data.id)
        const configurationBody = {
          basicOptions: configResponse.data.basicOptions,
          brandingOptions: configResponse.data.brandingOptions,
          orderOptions: configResponse.data.orderOptions,
          regOptions: configResponse.data.regOptions,
          organizationOptions: configResponse.data.organizationOptions,
          url: configResponse.data.url
        }
        return configurationBody;
      })
      .catch((err) => {
        throw err;
      });
  },
  updateConfigurations: (configChanges: configInterface) => {
    const config = {
      method: "PUT",
      url: `${mel_url}/api/configure`,
      data: configChanges,
      headers: {
        "Access-Control-Allow-Origin": "*"
      }
    };
    return axios(config)
      .then((configResponse: AxiosResponse) => {
        return configResponse.data;
      })
      .catch((err) => {
        throw err;
      });
  },
  updateBasicConfig: (basicChanges: basicOptionsInterface) => {
    const config = {
      method: "PUT",
      url: `${mel_url}/api/configure/basic`,
      data: basicChanges,
      headers: {
        "Access-Control-Allow-Origin": "*"
      }
    };
    return axios(config)
      .then((basics: AxiosResponse) => {
        return JSON.parse(basics.config.data);
      })
      .catch((err) => {
        throw err;
      });
  },
  updateBrandingConfig: (basicChanges: brandingOptionsInterface) => {
    const config = {
      method: "PUT",
      url: `${mel_url}/api/configure/branding`,
      data: basicChanges,
      headers: {
        "Access-Control-Allow-Origin": "*"
      }
    };
    return axios(config)
      .then((branding: AxiosResponse) => {
        return JSON.parse(branding.config.data);
      })
      .catch((err) => {
        throw err;
      });
  },
  updateOrderingConfig: (basicChanges: orderingOptionsInterface) => {
    const config = {
      method: "PUT",
      url: `${mel_url}/api/configure/ordering`,
      data: basicChanges,
      headers: {
        "Access-Control-Allow-Origin": "*"
      }
    };
    return axios(config)
      .then((orders: AxiosResponse) => {
        return JSON.parse(orders.config.data);
      })
      .catch((err) => {
        throw err;
      });
  },
  updateRegConfig: (regChanges: regOptionsInterface) => {
    const config = {
      method: "PUT",
      url: `${mel_url}/api/configure/registrations`,
      data: regChanges,
      headers: {
        "Access-Control-Allow-Origin": "*"
      }
    };
    return axios(config)
      .then((regs: AxiosResponse) => {
        return JSON.parse(regs.config.data);
      })
      .catch((err) => {
        throw err;
      });
  },
  updateOrgConfigThresholds: (thresholdChanges: any) => {
    const config = {
      method: "PUT",
      url: `${mel_url}/api/configure/organization/thresholds`,
      data: thresholdChanges,
      headers: {
        "Access-Control-Allow-Origin": "*"
      }
    };
    return axios(config)
      .then((regs: AxiosResponse) => {
        return JSON.parse(regs.config.data);
      })
      .catch((err) => {
        throw err;
      });
  },
  addOrgCoordinator: (coordinator: any) => {
    const config = {
      method: "POST",
      url: `${mel_url}/api/configure/organization/coordinator/`,
      data: coordinator,
      headers: {
        "Access-Control-Allow-Origin": "*"
      }
    };
    return axios(config)
      .then((regs: AxiosResponse) => {
        return JSON.parse(regs.config.data);
      })
      .catch((err) => {
        throw err;
      });
  },
  updateOrgCoordinatorConfigDisplay: (displayChanges: any) => {
    const config = {
      method: "PUT",
      url: `${mel_url}/api/configure/organization/coordinator/display`,
      data: displayChanges,
      headers: {
        "Access-Control-Allow-Origin": "*"
      }
    };
    return axios(config)
      .then((regs: AxiosResponse) => {
        return JSON.parse(regs.config.data);
      })
      .catch((err) => {
        throw err;
      });
  },
  updateOrgCoordinatorConfigTable: (tableChanges: any) => {
    const config = {
      method: "PUT",
      url: `${mel_url}/api/configure/organization/coordinator/table`,
      data: tableChanges,
      headers: {
        "Access-Control-Allow-Origin": "*"
      }
    };
    return axios(config)
      .then((regs: AxiosResponse) => {
        return JSON.parse(regs.config.data);
      })
      .catch((err) => {
        throw err;
      });
  }
};
